import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash } from 'react-icons/fa';
import ReactPaginate from 'react-paginate';
import { Link, useLocation } from 'react-router-dom';
import ProformaInvoiceModal from './ProformaInvoiceModal';
import TaxDetailsList from './TaxDetailsList';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Container, Card, Tabs, Tab, Button } from 'react-bootstrap';
import { BiPencil } from "react-icons/bi";
import { BsChevronLeft } from "react-icons/bs";
const ProformaInvoiceList = ({ quotationId }) => {
    const [proformainvoices, setPerformaInvoices] = useState([]);
    const [quotationData, setQuotationData] = useState(null);

    const [showModal, setShowModal] = useState(false);
    const [selectedPerformaInvoiceId, setSelectedPerformaInvoiceId] = useState(null);
    const [selectedPerformaInvoiceData, setSelectedPerformaInvoiceData] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [activeTab, setActiveTab] = useState('profoList'); // Active tab state
    const [setupIdError, setSetupIdError] = useState('');
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const quotation_id = queryParams.get('quotation_id') || quotationId; // Use prop or query parameter

    const isPerformaInvoiceDetailsPage = location.pathname.includes('/proformainvoice/details/');

    useEffect(() => {
        if (!isPerformaInvoiceDetailsPage && quotation_id && currentPage === 0) {
            fetchPerformaInvoices(1); // Fetch orders only if we're on the list page
        }
    }, [quotation_id, currentPage, isPerformaInvoiceDetailsPage]);
    // Utility function at the top of the file
    // const splitOrderByRevenueType = (order) => {
    //     const subscriptionItems = [];
    //     const deploymentItems = [];
    //     let subscriptionTotal = 0;
    //     let deploymentTotal = 0;

    //     order.quotation?.product_item_details?.forEach(item => {
    //         const revenueType = item.product?.revenue_type;
    //         const itemTotal = parseFloat(item.subtotal) || 0;

    //         if (revenueType === 'deferred') {
    //             subscriptionItems.push(item);
    //             subscriptionTotal += itemTotal;
    //         } else if (revenueType === 'immediate') {
    //             deploymentItems.push(item);
    //             deploymentTotal += itemTotal;
    //         }
    //     });

    //     return {
    //         subscription: {
    //             items: subscriptionItems,
    //             total: subscriptionTotal,
    //             count: subscriptionItems.length
    //         },
    //         deployment: {
    //             items: deploymentItems,
    //             total: deploymentTotal,
    //             count: deploymentItems.length
    //         }
    //     };
    // };
    // Split order by revenue type
const splitOrderByRevenueType = (order) => {
    const quotation = order.quotation;
    
    // Get totals from quotation data
    const totalAmountWithSubscription = parseFloat(quotation?.total_amount_with_subscription) || 0;
    const deploymentAmount = parseFloat(quotation?.deplyment_amount) || 0;
    
    // If we have the actual amounts from quotation, use them
    if (totalAmountWithSubscription > 0 || deploymentAmount > 0) {
        const subscriptionItems = [];
        const deploymentItems = [];
        
        // Distribute products based on their characteristics
        quotation?.product_item_details?.forEach(item => {
            const product = item.product;
            const isServiceProduct = product?.license_type?.toLowerCase() === 'service';
            
            if (isServiceProduct) {
                deploymentItems.push(item);
            } else {
                subscriptionItems.push(item);
            }
        });

        return {
            subscription: {
                items: subscriptionItems,
                total: totalAmountWithSubscription,
                perMonthTotal: totalAmountWithSubscription / (quotation?.subscription_period || 1),
                count: subscriptionItems.length
            },
            deployment: {
                items: deploymentItems,
                total: deploymentAmount,
                count: deploymentItems.length
            }
        };
    }

    // Fallback to calculation based on pricing data
    const subscriptionItems = [];
    const deploymentItems = [];
    let subscriptionTotal = 0;
    let deploymentTotal = 0;

    const subscriptionPeriod = quotation?.subscription_period || 1;
    const selectedLicenseType = quotation?.license_type_name?.toLowerCase();

    quotation?.product_item_details?.forEach(item => {
        const product = item.product;
        const pricings = product?.pricings || [];
        
        // Find matching pricing
        let matchingPricing = null;
        if (selectedLicenseType && pricings.length > 0) {
            matchingPricing = pricings.find(p => 
                p.license_model?.toLowerCase() === selectedLicenseType
            );
        }
        if (!matchingPricing && pricings.length > 0) {
            matchingPricing = pricings[0];
        }

        const isServiceProduct = product?.license_type?.toLowerCase() === 'service';

        if (matchingPricing) {
            const subscriptionAmount = parseFloat(matchingPricing.price) || 0;
            const deploymentAmount = parseFloat(matchingPricing.deployment_cost) || 0;
            const itemQuantity = parseFloat(item.quantity) || 1;

            if (isServiceProduct) {
                // Service products go to deployment
                const itemDeploymentTotal = deploymentAmount * itemQuantity;
                if (itemDeploymentTotal > 0) {
                    deploymentItems.push({
                        ...item,
                        deploymentAmount: itemDeploymentTotal,
                        totalAmount: itemDeploymentTotal
                    });
                    deploymentTotal += itemDeploymentTotal;
                }
            } else {
                // Regular products: both subscription and deployment
                const itemSubscriptionTotal = subscriptionAmount * itemQuantity;
                const itemDeploymentTotal = deploymentAmount * itemQuantity;

                if (itemSubscriptionTotal > 0) {
                    subscriptionItems.push({
                        ...item,
                        amountPerMonth: itemSubscriptionTotal,
                        totalAmount: itemSubscriptionTotal * subscriptionPeriod
                    });
                    subscriptionTotal += itemSubscriptionTotal * subscriptionPeriod;
                }

                if (itemDeploymentTotal > 0) {
                    deploymentItems.push({
                        ...item,
                        deploymentAmount: itemDeploymentTotal,
                        totalAmount: itemDeploymentTotal
                    });
                    deploymentTotal += itemDeploymentTotal;
                }
            }
        } else {
            // Fallback
            const itemTotal = parseFloat(item.subtotal) || 0;
            if (isServiceProduct) {
                deploymentItems.push({
                    ...item,
                    deploymentAmount: itemTotal,
                    totalAmount: itemTotal
                });
                deploymentTotal += itemTotal;
            } else {
                subscriptionItems.push({
                    ...item,
                    amountPerMonth: itemTotal,
                    totalAmount: itemTotal * subscriptionPeriod
                });
                subscriptionTotal += itemTotal * subscriptionPeriod;
            }
        }
    });

    return {
        subscription: {
            items: subscriptionItems,
            total: subscriptionTotal,
            perMonthTotal: subscriptionTotal / (subscriptionPeriod || 1),
            count: subscriptionItems.length
        },
        deployment: {
            items: deploymentItems,
            total: deploymentTotal,
            count: deploymentItems.length
        }
    };
};



    const fetchPerformaInvoices = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/proformainvoice?quotation_id=${quotation_id}&page=${page}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });

            const { data, current_page, last_page } = response.data.proformainvoice;
            setPerformaInvoices(data);
            setCurrentPage(current_page - 1);
            setPageCount(last_page);
            const fetchedQuotationData = response?.data?.quotation;

            // if (fetchedQuotationData) {
            //     setQuotationData(fetchedQuotationData);  // Set quotation data into state
            //     console.log('Fetched Quotation Data:', fetchedQuotationData);
            // } 
            if (fetchedQuotationData) {
                const quotationWithSplit = {
                    ...fetchedQuotationData,
                    revenueSplit: splitOrderByRevenueType({ quotation: fetchedQuotationData })
                };
                setQuotationData(quotationWithSplit);
            }
            else {
                console.log('Quotation data not found in the response');
            }

        } catch (error) {
            console.error('Error fetching proformainvoices:', error);
        }
    };




    const deletePerformaInvoice = async (id, journalId) => {
        console.log("Delete function triggered"); // Debugging

        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        });

        console.log("Swal result:", result); // Debugging

        if (!result.isConfirmed) {
            console.log("Delete cancelled");
            return; // Exit if the user cancels
        }

        try {
            console.log("Sending DELETE request...");
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const API = process.env.REACT_APP_WEBZASH_URL;
            const API_KEY = process.env.REACT_APP_API_KEY;

            await axios.delete(`${backendUrl}/api/proformainvoice/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            if (journalId) {
                await axios.delete(`${API}/api/entries/delete/journal/${journalId}`, {
                    headers: {
                        'x-api-key': API_KEY,
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    }
                });
            }
            // Remove from UI
            setPerformaInvoices((prevInvoices) =>
                prevInvoices.filter(invoice => invoice.id !== id)
            );

            console.log("Delete successful!");

            // Show success alert
            Swal.fire("Deleted!", "The proforma invoice has been deleted.", "success");

        } catch (error) {
            console.error('Error deleting proforma invoice:', error);

            Swal.fire("Error!", "Failed to delete proforma invoice. Please try again.", "error");
        }
    };

    const handleCreateProformaInvoice = (newInvoice) => {
        setPerformaInvoices(prevState => [newInvoice, ...prevState]);
    };
    const handleShowModal = () => {
        // First, ensure quotationData is available

        setShowModal(true);  // Open the modal if quotationData is available

    };

    const handleCloseModal = () => {
        console.log('Modal Closing');
        setShowModal(false);
    };

    const handlePageClick = (data) => {
        const selectedPage = data.selected + 1;
        fetchPerformaInvoices(selectedPage);
    };

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };
    const [dateFilterDropdown, setDateFilterDropdown] = useState(false);
    const [dateRange, setDateRange] = useState({ from: '', to: '' });
    const [orgFilter, setorgFilter] = useState('');
    const [typeFilter, setTypeFilter] = useState('');
    const [filterDropdown, setFilterDropdown] = useState(null);
    const [deals, setDeals] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');



    // const { totalVatAmount, totalAmountWithVat } = calculateTotals();

    const filteredProformas = proformainvoices.filter(item => item.quotation_id === quotationData?.id);
    const sortedProformas = filteredProformas.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    const latestProforma = sortedProformas.length > 0 ? sortedProformas[0] : null;

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Page Title */}
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0  d-flex align-items-center">
                                    <BsChevronLeft
                                        className='back-button1'
                                        onClick={() => navigate(-1)}
                                    />
                                    <span>Proforma Invoice</span>
                                </h4>
                                <div className="page-title-right"></div>
                            </div>
                        </div>
                    </div>
                    <div className="p-6 max-w-7xl mx-auto">

                        <>
                            {proformainvoices && proformainvoices.length > 0 ? (
                                <div className="row">
                                    {/* Left Side - Project & Client Summary + Total Proforma Amount */}
                                    <div className="col-md-10">
                                        <Card className="mb-3 shadow-lg rounded-3 p-2 border-0 card-bg">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <Card.Title className="fw-bold font-size-14 text-primary">
                                                    {quotationData?.ref_no || 'N/A'}
                                                </Card.Title>
                                            </div>

                                            <Card.Body className="pt-2">
                                                <div className="row">
                                                    {/* Client Details */}
                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <span className="text-muted d-block card-label"><strong>Client:</strong></span>
                                                            <span className="text-muted card-value">{quotationData?.project?.client?.name || '-'}</span>
                                                        </div>
                                                        <div className="mb-2">
                                                            <span className="text-muted d-block card-label"><strong>Project:</strong></span>
                                                            <span className="text-muted card-value">{quotationData?.project?.name || '-'}</span>
                                                        </div>

                                                    </div>

                                                    {/* Proforma Total */}
                                                    <div className="col-md-4">
                                                        <div className="mb-3">
                                                            <span className="text-muted d-block card-label"><strong>Balance:</strong></span>
                                                            <span className="fw-semibold text-success card-value">
                                                                {parseFloat(latestProforma?.balance || 0).toFixed(2)}%
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>

                                    <div className="col-md-2">
                                        <Card className="shadow-lg border-0 rounded-3 p-1">
                                            <Card.Body className="d-flex flex-column justify-content-between mb-1">
                                                <small className="fw-bold text-muted">SUMMARY</small>

                                                <div>
                                                    <div className="mt-2">
                                                        <div className="d-flex align-items-center mb-2">

                                                            <div className='proforma-total'></div>
                                                            <div>
                                                                <h5 className="mb-0 fw-bold font-size-16">{parseFloat(proformainvoices[0]?.quot_total_amount_with_vat || 0).toFixed(2)}</h5>
                                                                <small className="text-muted font-size-13">Total Amount</small>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex align-items-center">
                                                            <div className='proforma-received'></div>
                                                            <div>
                                                                <h5 className="mb-0 fw-bold font-size-16">{parseFloat(latestProforma?.total_amount_received || 0).toFixed(2)}</h5>
                                                                <small className="text-muted font-size-13">Invoiced Amount</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                </div>
                            ) : (
                                <div className="text-center text-muted">No Proforma Invoices found.</div>
                            )}
                        </>
                        <div className="row">
                            <div className="col-xl-12 col-lg-8">
                                <div className="card">
                                    <ul className="nav nav-tabs nav-tabs-custom justify-content-start pt-2 font-size-13" role="tablist">
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${activeTab === 'profoList' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('profoList')}
                                                role="tab"
                                            >
                                                Proforma Invoice
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${activeTab === 'taxList' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('taxList')}
                                                role="tab"
                                            >
                                                TaxInvoices
                                            </a>
                                        </li>



                                    </ul>

                                    <div className="tab-content p-4">
                                        {/* Contact List Tab */}
                                        {activeTab === "profoList" && (
                                            <div className="tab-pane active" id="contact-list" role="tabpanel">
                                                <div className="p-3">
                                                    <div>
                                                        <button
                                                            type="button"
                                                            className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                            onClick={() => handleShowModal()}
                                                            data-bs-toggle="tooltip"
                                                            data-bs-placement="top"
                                                            id="tool"
                                                            title="Add Proforma"
                                                        >
                                                            <i className="mdi mdi-plus" style={{ fontSize: "16px" }}></i>
                                                        </button><br /><br />
                                                        <table className="table table-hover datatable dt-responsive nowrap view-table font-size-13" >
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col">#</th>
                                                                    <th scope="col">Reference Number</th>
                                                                    <th scope="col">Advanced Amount</th>
                                                                    {/* <th scope="col">Deduction Amount</th> */}
                                                                    <th scope="col"> Received Amount</th>
                                                                    <th scope="col">Total Amount Received</th>
                                                                    <th scope="col">Balance Amount</th>

                                                                    <th scope="col">Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {Array.isArray(proformainvoices) && proformainvoices.length > 0 ? (
                                                                    proformainvoices.map((proformainvoice, index) => (
                                                                        <tr key={proformainvoice.id}>
                                                                            <td>{index + 1}</td>
                                                                            <td><Link to={`/proformainvoice/details/${proformainvoice.id}`} className="dropdown-item">{proformainvoice.ref_no}</Link></td>
                                                                            <td>{proformainvoice.advanced_amount}%</td>
                                                                            {/* <td>{proformainvoice.deduction_amount||0}</td> */}

                                                                            <td>{proformainvoice.total_with_vat}</td>

                                                                            <td>{proformainvoice.total_amount_received}</td>
                                                                            <td>{proformainvoice.balance}%</td>

                                                                            <td>
                                                                                {/* Action buttons for Edit and Delete */}
                                                                                <div className="dropdown">
                                                                                    <i
                                                                                        className="mdi mdi-dots-horizontal font-size-18"
                                                                                        data-bs-toggle="dropdown"
                                                                                        aria-expanded="false"
                                                                                        style={{ cursor: 'pointer' }}
                                                                                    ></i>
                                                                                    <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                                        <li>
                                                                                            <Link to={`/proformainvoice/details/${proformainvoice.id}`} className="dropdown-item">
                                                                                                View Details
                                                                                            </Link>
                                                                                        </li>

                                                                                        <li>
                                                                                            <button
                                                                                                className="dropdown-item"
                                                                                                onClick={() => deletePerformaInvoice(proformainvoice.id, proformainvoice.journal_id)}
                                                                                            >
                                                                                                Delete
                                                                                            </button>
                                                                                        </li>
                                                                                    </ul>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="6" className="text-center">No proforma invoices</td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {activeTab === "taxList" && (
                                            <div className="tab-pane active" id="project-list" role="tabpanel">
                                                <div className="p-3">
                                                    <div>
                                                        <br /><br />
                                                        <table className="table table-hover datatable dt-responsive nowrap view-table font-size-13" >

                                                            <thead>
                                                                <tr>
                                                                    <th scope="col">#</th>
                                                                    <th scope="col">PI Id</th>
                                                                    <th scope="col">Tax Id</th>
                                                                    <th scope="col">VAT Amount</th>
                                                                    <th scope="col">Total Amount with VAT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {proformainvoices
                                                                    .filter(invoice => invoice.tax_invoice_generated)
                                                                    .map((invoice, index) => (
                                                                        <tr key={invoice.id}>
                                                                            <td>{index + 1}</td> {/* This is the index column */}
                                                                            <td>{invoice.ref_no}</td>
                                                                            <td>
                                                                                {invoice.tax_invoice.ref_no}</td>
                                                                            <td>{invoice.tax_invoice.vat_amount}</td>
                                                                            <td>{invoice.tax_invoice.total_with_vat}</td>
                                                                        </tr>
                                                                    ))}
                                                            </tbody>
                                                        </table>



                                                    </div>

                                                </div>
                                            </div>
                                        )}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ProformaInvoiceModal
                showModal={showModal}
                handleClose={handleCloseModal}
                quotationData={quotationData || {}} // Pass the fetched quotation data
                quotationId={quotation_id} // Pass the quotationId
                handleCreate={handleCreateProformaInvoice}
                fetchDeals={fetchPerformaInvoices}
            />
        </div>
    );
};
export default ProformaInvoiceList;

